import { useState } from 'react'
import { projectAPI } from '../../../api';

import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ModelsModal } from './ModelsModal';
import { TagsInput } from "react-tag-input-component";
import { Modal } from '../../../components/Modal'
import toastr from 'toastr'

interface Props {
    project: any,
    setProject: (project: any) => void
}

const updateSetting = async (setProject: (project:any) => void, project:any, type: string, attribute_name: string, attribute_value: boolean | string | number, showToast: boolean = false) => {
  await projectAPI.updateSetting(project.id, type, {'attribute_name': type != 'content' ? attribute_name.replace('response_','').replace('prompt_','') : attribute_name, 'attribute_value': attribute_value})
  showToast && toastr.info('Updated')
  setProject({ ...project, [attribute_name]: attribute_value })
}

const updateSettingCheckbox = (setProject: (project:any) => void, project:any, type: string, attribute_name: string, attribute_value: boolean) => {
  return <div className="form-check form-switch form-check-custom">
    <input 
      className="form-check-input h-20px w-30px" 
      type="checkbox" 
      checked={attribute_value}
      disabled={attribute_name === 'classifier_driven_generation' && project.origin === project.id}
      onChange={() => {
        updateSetting(setProject, project, type, attribute_name, !attribute_value)
      }}
    />
  </div>
}

const UpdateSettingNumber: React.FC<{
  setProject: (project: any) => void;
  project: any;
  type: string;
  label: string;
  attribute_name: string;
  attribute_value: number;
}> = ({ setProject, project, type, label, attribute_name, attribute_value }) => {
  const [value, setValue] = useState<number>(attribute_value);

  return (
    <div className="d-flex flex-column">
      <label className="text-gray-800">{label}</label>
      <div className="d-flex align-items-center border border-gray-300 rounded mb-1">
        <input
          type="number"
          className="form-control border-0 form-control-transparent form-control-sm"
          value={value}
          onChange={(e) => {
            setValue(parseInt(e.target.value));
          }}
        />
      </div>
      <button
        type="button"
        className="btn btn-light-dark btn-sm fs-8 px-2 py-1"
        onClick={() => {
          updateSetting(setProject, project, type, attribute_name, value, true);
        }}
        disabled={value === attribute_value}
      >
        Update
      </button>
    </div>
  );
};

const TriggeringTerms = ({setProject, project, type, attribute_name, attribute_value = ""}: {
  setProject: (project: any) => void;
  project: any;
  type: string;
  attribute_name: string;
  attribute_value?: string;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [terms, setTerms] = useState<string[]>(attribute_value ? attribute_value.split(',').map(keyword => keyword.trim()) : [])
  return (
    <div className="mt-1">
      <button className="btn btn-primary btn-sm fs-8 px-2 py-1" onClick={() => {
        setShowModal(true)
      }}>Manage Triggering Terms</button>
      <Modal show={showModal} handleClose={()=>setShowModal(false)} dialogClassName="" title="Manage Triggering Terms">
        <TagsInput
          value={terms}
          onChange={setTerms}
          placeHolder={`Enter triggering terms`}
        />
        <button className="btn btn-light-dark btn-sm fs-8 px-2 py-1 mt-1 me-1" onClick={() => {
          setTerms([])
        }}>Clear</button>
        <button className="btn btn-primary btn-sm fs-8 px-2 py-1 mt-1" onClick={() => {
          updateSetting(setProject, project, type, attribute_name, terms.join(','), true)
        }}>Update</button>
      </Modal>
    </div>
  )
}

const ContentFeatureSettings : React.FC<Props> = ({project, setProject}) => {

  const [showModelsModal, setShowModelsModal] = useState<boolean>(false)

  return <>
    {project.origin == project.id && 
    <>
      <div className="row">
        <div className={`col-lg-${project.origin == project.id ? '2' : '3'}`}>
          <div className="fs-6 fw-semibold">Default Parameters</div>
        </div>
        <div className={`col-lg-${project.origin == project.id ? '2' : '9'}`}>
            <button className="btn btn-light-dark btn-sm fs-8 px-2 py-1" onClick={() => {
              setShowModelsModal(true)
            }}>Manage</button>
        </div>
      </div>
      <div className="separator my-5"></div>
    </>
    }
    <div className="row g-2">
      <div className="col-lg-12 mb-2">
          <div className="fs-6 fw-bolder">Content Generation</div>
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">
          Fanar
        </div>
        {updateSettingCheckbox(setProject, project, 'content', 'classifier_driven_generation', project.classifier_driven_generation)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Prompt Intervention</div>
        {updateSettingCheckbox(setProject, project, 'content', 'prompt_intervention', project.prompt_intervention)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Prompt Blocklist Filter</div>
        {updateSettingCheckbox(setProject, project, 'content', 'prompt_blocklist_filter', project.prompt_blocklist_filter)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Prompt Safety Filter</div>
        {updateSettingCheckbox(setProject, project, 'content', 'prompt_safety_filter', project.prompt_safety_filter)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Deep Thinking</div>
        {updateSettingCheckbox(setProject, project, 'content', 'deep_thinking', project.deep_thinking)}
      </div>
      {project.classifier_driven_generation && 
      <>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">
            Prompt Rephrasing
          </div>
          {updateSettingCheckbox(setProject, project, 'content', 'prompt_rephrasing', project.prompt_rephrasing)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">
            Recency RAG
          </div>
          {updateSettingCheckbox(setProject, project, 'content', 'recency_rag', project.recency_rag)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">
            Biography RAG
          </div>
          {updateSettingCheckbox(setProject, project, 'content', 'biography_rag', project.biography_rag)}
        </div>
      </>
      }
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">
          Islamic RAG
          <OverlayTrigger
            key="islamic-rag-toggle"
            placement="top"
            overlay={
              <Tooltip id="islamic-rag-toggle">
                Fanar should be enabled for this with model `Fanar` or `IslamicRAG` should be used.
              </Tooltip>
            }
          >
            <i className="fa-solid fa-info-circle fs-7 ms-2"></i>
          </OverlayTrigger>
        </div>
        {updateSettingCheckbox(setProject, project, 'content', 'islamic_rag', project.islamic_rag)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Response Blocklist Filter</div>
        {updateSettingCheckbox(setProject, project, 'content', 'response_blocklist_filter', project.response_blocklist_filter)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Response Safety Filter</div>
        {updateSettingCheckbox(setProject, project, 'content', 'response_safety_filter', project.response_safety_filter)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Response Quran Validator</div>
        {updateSettingCheckbox(setProject, project, 'content', 'response_quran_validator', project.response_quran_validator)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Image Understanding</div>
        {updateSettingCheckbox(setProject, project, 'content', 'image_understanding', project.image_understanding)}
      </div>
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Video Understanding</div>
        {updateSettingCheckbox(setProject, project, 'content', 'video_understanding', project.video_understanding)}
      </div>
      {project.origin != project.id && 
      <>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Text To Speech</div>
          {updateSettingCheckbox(setProject, project, 'content', 'text_to_speech', project.text_to_speech)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Speech To Text</div>
          {updateSettingCheckbox(setProject, project, 'content', 'speech_to_text', project.speech_to_text)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Transcription</div>
          {updateSettingCheckbox(setProject, project, 'content', 'transcription', project.transcription)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Image Generation</div>
          {updateSettingCheckbox(setProject, project, 'content', 'image_generation', project.image_generation)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Translation</div>
          {updateSettingCheckbox(setProject, project, 'content', 'translation', project.translation)}
        </div>
      </>
      }
      {project.origin == project.id && 
      <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
        <div className="fs-6 fw-semibold">Attribution</div>
        {updateSettingCheckbox(setProject, project, 'content', 'attribution', project.attribution)}
      </div>
      }
    </div>
    {project.origin == project.id && 
      <>
      <div className="separator my-5"></div>
      <div className="row g-2">
        <div className="col-lg-12 mb-2">
            <div className="fs-6 fw-bolder">Prompt Features</div>
        </div>
        {project.deep_thinking && 
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Deep Thinking</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_deep_thinking', project.prompt_deep_thinking)}
        </div>
        }
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Speech to Text</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_speech_to_text', project.prompt_speech_to_text)}
        </div>
        
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Transcription</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_transcription', project.prompt_transcription)}
          {project.prompt_video_understanding &&
              <div className="d-flex flex-row gap-2 mt-2">
                <UpdateSettingNumber
                  setProject={setProject}
                  project={project}
                  label={'Max Files'}
                  type='prompt'
                  attribute_name='prompt_transcription_max_files'
                  attribute_value={project.prompt_transcription_max_files}
                />
                <UpdateSettingNumber
                  setProject={setProject}
                  project={project}
                  label={'Max File Size (MB)'}
                  type='prompt'
                  attribute_name='prompt_transcription_max_file_size'
                  attribute_value={project.prompt_transcription_max_file_size}
                />
              </div>
            }
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Text to Speech</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_text_to_speech', project.prompt_text_to_speech)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Image Generation</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_generation', project.prompt_image_generation)}
          {project.prompt_image_generation && 
          <>
            <TriggeringTerms
              setProject={setProject}
              project={project}
              type='prompt'
              attribute_name='prompt_image_generation_triggering_terms'
              attribute_value={project.prompt_image_generation_triggering_terms}
            />
            <div className="mt-2">
              <div className="fs-6 fw-semibold text-gray-800">Prompt Classification</div>
              {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_generation_classification', project.prompt_image_generation_classification)}
            </div>
            <div className="mt-2">
              <div className="fs-6 fw-semibold text-gray-800">Prompt Rephrasing</div>
              {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_generation_rephrasing', project.prompt_image_generation_rephrasing)}
            </div>
          </>
          }
        </div>
        {project.image_understanding && 
          <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
            <div className="fs-6 fw-semibold">Image Understanding</div>
            {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_understanding', project.prompt_image_understanding)}
            {project.prompt_image_understanding &&
              <div className="d-flex flex-row gap-2 mt-2">
                <UpdateSettingNumber
                  setProject={setProject}
                  project={project}
                  label={'Max Files'}
                  type='prompt'
                  attribute_name='prompt_image_understanding_max_files'
                  attribute_value={project.prompt_image_understanding_max_files}
                />
                <UpdateSettingNumber
                  setProject={setProject}
                  project={project}
                  label={'Max File Size (MB)'}
                  type='prompt'
                  attribute_name='prompt_image_understanding_max_file_size'
                  attribute_value={project.prompt_image_understanding_max_file_size}
                />
              </div>
            }
          </div>
        }
        {project.video_understanding && 
          <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
            <div className="fs-6 fw-semibold">Video Understanding</div>
            {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_video_understanding', project.prompt_video_understanding)}
            {project.prompt_video_understanding &&
              <div className="d-flex flex-row gap-2 mt-2">
                <UpdateSettingNumber
                  setProject={setProject}
                  project={project}
                  label={'Max Files'}
                  type='prompt'
                  attribute_name='prompt_video_understanding_max_files'
                  attribute_value={project.prompt_video_understanding_max_files}
                />
                <UpdateSettingNumber
                  setProject={setProject}
                  project={project}
                  label={'Max File Size (MB)'}
                  type='prompt'
                  attribute_name='prompt_video_understanding_max_file_size'
                  attribute_value={project.prompt_video_understanding_max_file_size}
                />
              </div>
            }
          </div>
        }
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Image Search</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_search', project.prompt_image_search)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Music Generation</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_music_generation', project.prompt_music_generation)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Translate</div>
          {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_translate', project.prompt_translate)}
        </div>
      </div>
      <div className="separator my-5"></div>
      <div className="row g-2">
        <div className="col-lg-12 mb-2">
            <div className="fs-6 fw-bolder">Response Features</div>
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Reaction</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_reaction', project.response_reaction)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Regenerate (last one)</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_regenerate', project.response_regenerate)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Text to Speech</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_text_to_speech', project.response_text_to_speech)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Image Generation</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_image_generation', project.response_image_generation)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Image Search</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_image_search', project.response_image_search)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Music Generation</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_music_generation', project.response_music_generation)}
        </div>
        <div className="col-lg-3 col-xl-2 border border-gray-400 p-3 rounded">
          <div className="fs-6 fw-semibold">Translate</div>
          {updateSettingCheckbox(setProject, project, 'response', 'response_translate', project.response_translate)}
        </div>
      </div>
      </>
      }
      <ModelsModal show={showModelsModal} projectId={project.id} name={project.name} handleClose={() => {
        setShowModelsModal(false)
      }}/>
  </>
}


export {ContentFeatureSettings, updateSettingCheckbox, updateSetting}